var $announcement = $('.js-announcement-parent');
if ($announcement.length) {
  var $firstH3 = $announcement.find('h3:contains("Available Contract Vehicles")');

  $('.js-announcement').insertBefore($firstH3);
};
